import React, { useState, useEffect } from "react";
import {
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Stepper,
  Step,
  StepLabel,
  Grid,
} from "@mui/material";
import StepCircle from "../StepCircle";
import api from "../../api";

const steps = ["Detalles del Documento", "Asignar Vehículo"];

const tipoOpciones = [
  { value: "cedula", label: "Cédula del Vehículo" },
  { value: "seguro", label: "Póliza de Seguro" },
  { value: "permiso", label: "Permiso de Circulación" },
  { value: "vtv", label: "Verificación Técnica Vehicular (VTV)" },
  { value: "grabado_autopartes", label: "Grabado de Autopartes" },
  { value: "informe_estado", label: "Informe de Estado Técnico" },
  { value: "tarjeta_ypf", label: "Tarjeta YPF" },
  { value: "otro", label: "Otro" },
];

const coberturaOpciones = [
  { value: "todo_riesgo", label: "Todo Riesgo Sin Franquicia" },
  { value: "garage", label: "Garage" },
  { value: "n_a", label: "N/A" },
];

const AgregarDocumentacion = ({ vehiculo, handleClose, onUpdate }) => {
  const [selectedVehiculo, setSelectedVehiculo] = useState(vehiculo || null);
  const [step, setStep] = useState(0);
  const [vehiculos, setVehiculos] = useState([]);

  const [documento, setDocumento] = useState({
    tipo: "",
    numero: "",
    fecha_emision: "",
    fecha_vencimiento: "",
    observaciones: "",
    archivo: null,
    suma_asegurada: "",
    tipo_cobertura: "",
    vehiculo: vehiculo?.id || "",
  });

  const [isStep1Valid, setIsStep1Valid] = useState(false);

  useEffect(() => {
    if (!vehiculo) {
      api.get("vehiculos/")
        .then((res) => setVehiculos(res.data))
        .catch(() => alert("Error al cargar vehículos."));
    }
  }, [vehiculo]);

  useEffect(() => {
    const { tipo, fecha_emision } = documento;
    setIsStep1Valid(tipo);
  }, [documento]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDocumento((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setDocumento((prev) => ({ ...prev, archivo: e.target.files[0] }));
  };

  const handleNext = () => {
    if (vehiculo) {
      handleSubmit(new Event("submit"));
    } else {
      setStep((prev) => prev + 1);
    }
  };

  const handleBack = () => setStep((prev) => prev - 1);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    for (const key in documento) {
      if (documento[key]) {
        formData.append(key, documento[key]);
      }
    }

    api
      .post("documentos/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        alert("Documento agregado correctamente");
        if (onUpdate) {
          onUpdate(res.data); // send the new data to parent
        }
        handleClose();
      })
      .catch(() => alert("Hubo un error al agregar el documento."));
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 600, margin: "0 auto" }}>
      <Typography variant="h6" sx={{ color: "#152d51", fontWeight: "bold" }}>
        Agregar Documento
      </Typography>

      <Stepper activeStep={step} alternativeLabel>
        {steps.map((label, i) => (
          <Step key={i}>
            <StepLabel StepIconComponent={StepCircle}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {step === 0 && (
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={6}>
            <FormControl fullWidth required>
              <InputLabel>Tipo</InputLabel>
              <Select
                name="tipo"
                value={documento.tipo}
                onChange={handleChange}
                label="Tipo"
              >
                {tipoOpciones.map((op) => (
                  <MenuItem key={op.value} value={op.value}>
                    {op.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Número (opcional)"
              name="numero"
              value={documento.numero}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Fecha de Emisión"
              name="fecha_emision"
              type="date"
              value={documento.fecha_emision}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Fecha de Vencimiento"
              name="fecha_vencimiento"
              type="date"
              value={documento.fecha_vencimiento}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {documento.tipo === "seguro" && (
            <>
              <Grid item xs={6}>
                <TextField
                  label="Suma Asegurada"
                  name="suma_asegurada"
                  type="number"
                  value={documento.suma_asegurada}
                  onChange={handleChange}
                  fullWidth
                  inputProps={{ min: 0, step: "0.01" }}
                />
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel>Tipo de Cobertura</InputLabel>
                  <Select
                    name="tipo_cobertura"
                    value={documento.tipo_cobertura}
                    onChange={handleChange}
                    label="Tipo de Cobertura"
                  >
                    {coberturaOpciones.map((op) => (
                      <MenuItem key={op.value} value={op.value}>
                        {op.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </>
          )}

          <Grid item xs={12}>
            <TextField
              label="Observaciones"
              name="observaciones"
              value={documento.observaciones}
              onChange={handleChange}
              fullWidth
              multiline
              rows={3}
            />
          </Grid>

          <Grid item xs={12}>
            <Button variant="outlined" component="label" fullWidth>
              Seleccionar Archivo...
              <input type="file" hidden onChange={handleFileChange} />
            </Button>
            {documento.archivo && (
              <Typography variant="caption">{documento.archivo.name}</Typography>
            )}
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleNext}
              sx={{ background: "#152d51" }}
              disabled={!isStep1Valid}
            >
              {vehiculo ? "Agregar Documento" : "Siguiente"}
            </Button>
          </Grid>
        </Grid>
      )}

      {step === 1 && (
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <FormControl fullWidth required>
              <InputLabel style={{ backgroundColor: "white" }}>
                Vehículo
              </InputLabel>
              <Select
                name="vehiculo"
                value={documento.vehiculo}
                onChange={handleChange}
              >
                {vehiculos.map((v) => (
                  <MenuItem key={v.id} value={v.id}>
                    {v.patente} - {v.marca} {v.modelo}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <Button variant="outlined" fullWidth onClick={handleBack}>
              Atrás
            </Button>
          </Grid>

          <Grid item xs={6}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ background: "#152d51" }}
            >
              Agregar Documento
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

export default AgregarDocumentacion;
